import { toAbsoluteUrl } from '~utils/assetsHelpers';
import { SelectOptionWithImage } from '~globals/types/commons';
import { SourceImportType } from '~globals/types/enums';

export const sourceImportType = [
  {
    name: 'Archivo o Planilla',
    image: {
      url: toAbsoluteUrl('/images/icon_source_file@2x.png'),
      alt: 'Archivo Logo',
    },
  },
  {
    name: 'Manual',
    image: {
      url: toAbsoluteUrl('/images/icon_source_manual@2x.png'),
      alt: 'Manual Logo',
    },
  },
  {
    name: 'Tienda Nube',
    image: {
      url: toAbsoluteUrl('/images/icon_source_tn@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    name: 'MercadoLibre',
    image: {
      url: toAbsoluteUrl('/images/icon_source_mp@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    name: 'WooCommerce',
    image: {
      url: toAbsoluteUrl('/images/icon_source_woo@2x.png'),
      alt: 'WooCommerce Logo',
    },
  },
  {
    name: 'FLEX',
    image: {
      url: toAbsoluteUrl('/images/icon_source_mp@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    name: 'Shopify',
    image: {
      url: toAbsoluteUrl('/images/icon_source_shopify@2x.png'),
      alt: 'Shopify Logo',
    },
  },
];

export const SOURCE_IMPORT_TYPES_OPTIONS: SelectOptionWithImage[] = [
  {
    label: 'Archivo o Planilla',
    value: SourceImportType.File,
    image: {
      url: toAbsoluteUrl('/images/icon_source_file@2x.png'),
      alt: 'Archivo Logo',
    },
  },
  {
    label: 'Manual',
    value: SourceImportType.Manual,
    image: {
      url: toAbsoluteUrl('/images/icon_source_manual@2x.png'),
      alt: 'Manual Logo',
    },
  },
  {
    label: 'Tienda Nube',
    value: SourceImportType.TiendaNube,
    image: {
      url: toAbsoluteUrl('/images/icon_source_tn@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    label: 'MercadoLibre',
    value: SourceImportType.MercadoLibre,
    image: {
      url: toAbsoluteUrl('/images/icon_source_mp@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    label: 'WooCommerce',
    value: SourceImportType.WooCommerce,
    image: {
      url: toAbsoluteUrl('/images/icon_source_woo@2x.png'),
      alt: 'WooCommerce Logo',
    },
  },
  {
    label: 'FLEX',
    value: SourceImportType.MFlex,
    image: {
      url: toAbsoluteUrl('/images/icon_source_mp@2x.png'),
      alt: 'MercadoLibre Logo',
    },
  },
  {
    label: 'Shopify',
    value: SourceImportType.Shopify,
    image: {
      url: toAbsoluteUrl('/images/icon_source_shopify@2x.png'),
      alt: 'Shopify Logo',
    },
  },
];
